$(function() {
    $("#cash-transactions").find("button.set-status").on('click', function(e) {
        e.preventDefault();

        var $el = $(this);
        var newStatus = $el.data('new-status');
        var url = $el.data('status-change-url');
        var date = $el.parent().prevAll('td.date').find('input').val();
        $.post(url, {'date' : date}, function (data) {
            window.location.reload();
        });
    });
});
